import { baseScopesRequiredPerField } from '@atlassian/jira-issue-adjustments/src/common.tsx';

export type SelectPublicGetValue = null | {
	id: string;
	value: string;
};

export const selectScopes = baseScopesRequiredPerField;
